// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"bc7a716f","513":"85861a9b","703":"ec5aea44","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};